<template>
  <b-sidebar
    id="sidebar-update-settings"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <!-- Uz Name -->
        <b-form-group
          :label="settings.label"
          label-for="value"
        >
          <v-select
            v-if="settings.key === 'MONITORING_ON_OF'"
            v-model="settings.value"
            :reduce="(option) => option.id"
            :options="monitoringOnOf"
            :get-option-label="(option) => option.name"
          />
          <b-form-input
            v-else
            id="value"
            v-model="settings.value"
            trim
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Update') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    settings: {
      get() {
        return this.$store.state[this.MODULE_NAME].settings
      },
      set(data) {
        this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      hide()
    },
    submit(hide) {
      this.$createSwal(this, { id: this.settings.id, body: { value: this.settings.value } }, `${this.MODULE_NAME}/patch`, () => {
        this.$emit('refetchData')
        this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      })
      hide()
    },
  },
  setup() {
    const MODULE_NAME = 'settings'
    const monitoringOnOf = [
      {
        id: '100',
        name: 'Faol',
      },
      {
        id: '200',
        name: 'Faol emas',
      },
    ]
    return {
      MODULE_NAME,
      monitoringOnOf,
    }
  },
}
</script>
